module.exports = __webpack_public_path__ + "static/media/dish_card9.a30e6166.png";